const deliveryColumns = (setDeliveryData, drivers, selectedDriver, deliveryData) => {
    return ([
      {
        name: ' ',
        width: '50px',
        cell: (row, index, column, id) => {
          return <input style={{ width: '25px', height: '25px' }} type="checkbox" checked={row.driver === selectedDriver.email ? true : false} disabled={row.completed || (row.driver && row.driver !== selectedDriver.email)} onChange={(e) => {
            console.log('modified delivery', row);
            setDeliveryData(row, e.target.checked);
          }} />
        }
      },
      {
        name: 'Order(s)',
        width: '180px',
        selector: row => row.orders.map(o => o.id).join(', ')
      },
      {
        name: 'Customer',
        width: '150px',
        selector: row => `${row.customer.lastName}, ${row.customer.firstName}`
      },
      {
        name: 'Company',
        selector: row => row.customer.company
      },
      {
      name: 'Address',
      wrap: true,
      selector: row => `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`,
      format: row => {
        let address = `${row.address.address1} ${row.address.address2 ? row.address.address2 : ''} ${row.address.city}, ${row.address.state} ${row.address.zip}`;
        return <span title={address}>{address}</span>
      }
      },
      {
        name: 'Status',
        selector: row => {
          if (row.completed) {
            return 'Completed';
          }
          else if (row.driver && row.driver === selectedDriver.email) {
            return `Assigned`
          }
          else if (row.driver && row.driver !== selectedDriver.email) {
            let driver = drivers.find(d => d.email === row.driver);
            return `Assigned (${driver.label})`;
          }       
          else
          {
            return 'Open';
          }
    
        }
      }, 
      {
        name: 'Delivery Time',
        selector: row => row.deliveryTime,
        format: row => {
          if(row.deliveryTime)
          {
            let time = row.deliveryTime.substring(row.deliveryTime.indexOf('T')+1, row.deliveryTime.lastIndexOf('.'));
            return <span title={time}>{time}</span>;
          }
          else
          {
            return '';
          }
        }
      }
    ]);
}
export default deliveryColumns;